import API from "../../configs/api";
import apiMethod from "../../../../utility/ApiMethodV2";

export const getListService = ({ codeLanguage }) => {
  return apiMethod.get(codeLanguage + API.GET_PRODUCT_LIST_V2);
};
